export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons-react/es/index.js
// module id = 248
// module chunks = 0 1